import { styled } from '@mui/material/styles'
import { Box, Stack, Typography, Tabs, Tab, IconButton } from '@mui/material'

export const StyledToolbar = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  background: '#FFFFFF',
  width: '100%'
})

export const StyledContainer = styled(Stack)({
  fontSize: '12px',
  lineHeight: '16px',
  color: '#656565',
  width: '100%',
  minHeight: '32px',
  height: '32px',
  alignItems: 'stretch',
  display: 'flex'
})

export const StyledTabsArea = styled(Stack)({
  width: '100%',
  gap: '8px',
  height: '32px',
  alignItems: 'stretch',
  display: 'flex'
})

export const StyledTabs = styled(Tabs)({
  minHeight: '32px',
  height: '32px',
  width: '100%',
  flex: '1 1 auto',
  minWidth: 0,
  padding: 0,
  border: 'none',
  borderRadius: '12px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'stretch',
  alignSelf: 'stretch',
  overflow: 'visible',
  backgroundColor: '#FFFFFF',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    border: '1px solid #EFEFEF',
    borderRadius: '12px',
    pointerEvents: 'none',
    zIndex: 0
  },
  '& .MuiTabs-scroller': {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
    overflow: 'visible !important',
    position: 'relative',
    zIndex: 1
  },
  '& .MuiTabs-flexContainer': {
    width: '100%',
    height: '100%',
    alignItems: 'stretch',
    gap: 0
  },
  '& .MuiTabs-indicator': {
    display: 'none'
  },
  '& .MuiTab-root': {
    flex: '0 0 50%',
    width: '50%',
    height: '100%',
    minWidth: 0,
    maxWidth: 'none',
    textTransform: 'none'
  },
  '& .MuiButtonBase-root': {
    minHeight: '100%'
  }
})

export const StyledTab = styled(Tab, {
  shouldForwardProp: prop => prop !== 'empty'
})(({ empty }) => ({
  flex: '0 0 50%',
  width: '50%',
  maxWidth: 'none',
  minHeight: '100%',
  height: '100%',
  padding: '0 14px',
  borderRadius: 0,
  border: '1px solid transparent',
  boxSizing: 'border-box',
  color: empty ? '#DCDCDC' : '#656565',
  backgroundColor: 'transparent',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'stretch',
  transform: 'translateY(0)',
  '&.Mui-selected': {
    color: '#2570EB',
    backgroundColor: '#F2F8FD',
    border: '1px solid #D6E5FC',
    borderRadius: '12px',
    height: '100%',
    zIndex: 1
  },
  '&.Mui-selected:first-of-type': {
    margin: '0 0 -1px -1px'
  },
  '&.Mui-selected:last-of-type': {
    margin: '0 -1px -1px 0'
  },
  '&.Mui-disabled': {
    color: '#DCDCDC',
    backgroundColor: 'transparent',
    opacity: 1
  }
}))

export const StyledTabContent = styled(Stack)({
  color: 'inherit',
  width: '100%',
  minWidth: 0,
  alignItems: 'center',
  justifyContent: 'center'
})

export const StyledTabLabel = styled(Typography, {
  shouldForwardProp: prop => prop !== 'empty'
})(({ empty }) => ({
  color: empty ? '#DCDCDC' : 'inherit',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 400,
  whiteSpace: 'nowrap'
}))

export const StyledCountChip = styled(Box, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'empty'
})(({ active, empty }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: active ? '#FFFFFF' : '#F7F7F7',
  color: active ? '#2570EB' : (empty ? '#DCDCDC' : '#656565'),
  border: `1px solid ${active ? '#E4EEFA' : 'transparent'}`,
  fontSize: '10px',
  fontWeight: 500,
  width: '24px',
  minWidth: '24px',
  height: '16px',
  lineHeight: '16px',
  padding: 0,
  borderRadius: '6px',
  boxSizing: 'border-box'
}))

export const StyledActionButton = styled(IconButton)({
  flex: '0 0 32px',
  width: '32px',
  height: '32px',
  minWidth: '32px',
  minHeight: '32px',
  border: '1px solid #EFEFEF',
  borderRadius: '12px',
  boxSizing: 'border-box',
  backgroundColor: '#FFFFFF',
  color: '#464646',
  padding: 0,
  fontSize: '13px',
  alignSelf: 'stretch',
  transition: 'none',
  '&:hover': {
    backgroundColor: '#FFFFFF'
  },
  '& .MuiTouchRipple-root': {
    display: 'none'
  }
})

export const StyledIcon = styled('i')(({ theme }) => ({
  cursor: 'pointer',
  fontSize: '16px',
  color: theme.palette.text.body.tertiary
}))
